(() => {
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined") return require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported');
  });

  // src/js/cart-flow.js
  __require(["Message", "fingerprint"], async function(Message, Fingerprint2) {
    function updateDiscountedPrice() {
      const price = settings.cart_total_price ? settings.cart_total_price : getSubtotal();
      $(".docapp-cart-item.docapp-cart-subtotal .money").html("\u20AC" + price.toFixed(2).replace(".", ","));
    }
    function getCookie(n) {
      let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
      return a ? a[1] : "";
    }
    function getSubtotal() {
      let data = getCart();
      if (data) {
        settings.cart_total_price = data.total_price / 100;
        return data.total_price / 100;
      }
    }
    theme.Cart.prototype._createCart = function() {
      updateDiscountedPrice();
    };
    function updateCart(updates) {
      let data = $.ajax({
        type: "POST",
        async: false,
        url: window.Shopify.routes.root + "cart/update.js",
        dataType: "json",
        data: {
          updates
        }
      }).responseJSON;
      return data;
    }
    function mapProducts(product, quantity) {
      return {
        package: product["dataset"]["cartItemPackage"],
        index: product["dataset"]["cartItemIndex"],
        bundle: product["dataset"]["bundle"],
        id: product["dataset"]["cartItemId"],
        quantity: quantity[0],
        cartVariantId: product["dataset"]["cartVariantId"]
      };
    }
    function checkSameProducts(refresh = false) {
      const cart_info = getCart(refresh), products = $(".cart-item");
      let checked_products = [], updates = {};
      $.each(products, function(i) {
        const product = mapProducts(
          products[i],
          cart_info.items.filter((e) => products[i]["dataset"]["cartVariantId"] == e.id).map((e) => e.quantity)
        );
        if (product.quantity > 1 && product.cartVariantId) {
          updates[product.cartVariantId] = 1;
          Message.genericError(cart.errors.same_product_same_duration);
        }
        if (product.package !== void 0) {
          let similar_products = $(
            '[data-cart-item-package="' + product.package + '"][data-cart-item-index!="' + product.index + '"]'
          );
          if (similar_products.length >= 1) {
            $.each(similar_products, function(j) {
              if ($.inArray(similar_products[j]["dataset"]["cartItemId"], checked_products) === -1) {
                let similar_index = similar_products[j]["dataset"]["cartItemIndex"];
                if (similar_index < product.index) {
                  if ($(
                    '[data-cart-item-package="' + product.package + '"][data-cart-item-index="' + product.index + '"] [data-cart-remove]'
                  )[0]) {
                    $(
                      '[data-cart-item-package="' + product.package + '"][data-cart-item-index="' + product.index + '"] [data-cart-remove]'
                    )[0].click();
                    Message.genericError(cart.errors.same_product);
                  }
                  checked_products.push(similar_products[j]["dataset"]["cartItemId"]);
                  checked_products.push(product.id);
                } else if (similar_index > product.index && $(
                  '[data-cart-item-package="' + product.package + '"][data-cart-item-index="' + similar_index + '"] [data-cart-remove]'
                )[0] != void 0) {
                  if ($(
                    '[data-cart-item-package="' + product.package + '"][data-cart-item-index="' + similar_index + '"] [data-cart-remove]'
                  )[0]) {
                    $(
                      '[data-cart-item-package="' + product.package + '"][data-cart-item-index="' + similar_index + '"] [data-cart-remove]'
                    )[0].click();
                    Message.genericError(cart.errors.same_product);
                  }
                  checked_products.push(similar_products[j]["dataset"]["cartItemId"]);
                  checked_products.push(product.id);
                }
              }
            });
          }
        } else if (product.bundle !== void 0) {
          getBundleProducts(product.bundle, product.index);
        }
      });
      if (Object.keys(updates).length !== 0) {
        const response = updateCart(updates);
        if (response.total_price) {
          settings.cart_total_price = response.total_price / 100;
        }
        updateDiscountedPrice();
      }
    }
    function getBundleProducts(skus, index) {
      let skus_arr = skus.split(",");
      $.each(skus_arr, function(k) {
        $.get("/search?type=product&view=sku&q=variants.sku:" + skus_arr[k], function(item) {
          if (item) {
            let product_rough = JSON.parse(item);
            let product = product_rough.products[0];
            $.get("/products/" + product.handle + "?view=json", function(data) {
              if (data) {
                let metafields = JSON.parse(data);
                let similar_products = $(
                  '[data-cart-item-package="' + metafields.metafields.package_ids + '"][data-cart-item-index!="' + index + '"]'
                );
                if (similar_products.length > 0) {
                  const title = "Attenzione", product_titles = [];
                  $.each(similar_products, function(e, i) {
                    product_titles.push($(this).find("[data-cart-item-title]")[0].innerText.toLowerCase());
                  });
                  Message.genericError(cart.errors.same_product_bundle + ": " + product_titles.join(","), title);
                }
              }
            });
          }
        });
      });
    }
    function log(value) {
      console.log(value);
    }
    function isCouponAds(coupon) {
      var email = settings.customer_email;
      var data = $.ajax({
        type: "GET",
        timeout: cart.debug ? 1e4 : 5e3,
        async: false,
        url: location.origin + settings.api_url + "/ads/coupon/is-ads",
        data: {
          coupon,
          email
        }
      }).responseJSON;
      if (data !== void 0 && data.success === true) {
        return data.data.isCouponAds;
      } else {
        Message.genericError();
        console.error(data);
        return false;
      }
    }
    function editCartAttributes(attributes) {
      var data = $.ajax({
        type: "POST",
        timeout: cart.debug ? 1e4 : 5e3,
        async: false,
        url: ".".concat(cart.update_url, ".js"),
        data: attributes
      }).responseJSON;
      if (data === void 0 || data.success !== true) {
        console.error(data);
      }
    }
    function isAdsParamsNeeded() {
      const coupon = document.querySelector(".docapp-coupon-input--bean-container--bean-remove") ? document.querySelector(".docapp-coupon-input--bean-container--bean-remove").dataset.code : false;
      return coupon && isCouponAds(coupon);
    }
    function handleSubscriptions() {
      console.log("handleSubscriptions", cart);
      let attributes = { "attributes[redirectUrl]": "" };
      if (isAdsParamsNeeded()) {
        attributes = {
          "attributes[redirectUrl]": cart.redirectUrl
        };
      }
      if (cart.hasFantacalcio == "true") {
        const gigyaToken = getCookie("gigyaToken");
        if (gigyaToken && gigyaToken != "") {
          if (cart.fantacalcioRedirectUrl.indexOf("?") != -1) {
            attributes["attributes[fantacalcioRedirectUrl]"] = cart.fantacalcioRedirectUrl + "&token=" + gigyaToken + "&collection=" + (theme.permanentDomain == "corrieredellosport.myshopify.com" ? "cds" : "ts");
          } else {
            attributes["attributes[fantacalcioRedirectUrl]"] = cart.fantacalcioRedirectUrl + "?token=" + gigyaToken + "&collection=" + (theme.permanentDomain == "corrieredellosport.myshopify.com" ? "cds" : "ts");
          }
        } else {
          attributes["attributes[fantacalcioRedirectUrl]"] = cart.fantacalcioRedirectUrl;
        }
      }
      editCartAttributes(attributes);
    }
    function bindFormSubmit() {
      const $submitButtons = $(
        'form[action="/cart"] input[type="submit"], [name="checkout"], [href="/checkout"], form[action="/checkout"] input[type="submit"], .checkout_button'
      );
      $submitButtons.click(function(evt) {
        if (evt.originalEvent.isTrusted) {
          evt.preventDefault();
          checkSameProducts(true);
          handleSubscriptions();
          console.log("submitting form");
          evt.target.click();
        }
      });
    }
    function autoApplyCoupon() {
      const discount_code_app_input = document.querySelector(".docapp-cart-with-coupon-summary");
      if (discount_code_app_input) {
        const config = { attributes: false, childList: true, subtree: false };
        let params = location.href.split("?");
        if (params[1] && params[1].indexOf("&") != -1) {
          params = params[1].split("&");
        }
        let discount_code = "";
        params.forEach((p) => {
          const key = p.split("=")[0];
          const value = p.split("=")[1];
          if (key == "coupon_auto") {
            log("coupon found in URL");
            discount_code = value;
          }
        });
        const callback = () => {
          const discount_input = discount_code_app_input.querySelector(".docapp-coupon-input--input");
          const discount_submit = discount_code_app_input.querySelector(".docapp-coupon-input--button");
          if (discount_input && discount_submit) {
            observer.disconnect();
            discount_input.value = discount_code;
            discount_submit.click();
          }
        };
        const observer = new MutationObserver(callback);
        observer.observe(discount_code_app_input, config);
      }
    }
    function init() {
      bindFormSubmit();
      checkSameProducts();
      autoApplyCoupon();
    }
    init();
  })();
})();
